import { render, staticRenderFns } from "./commitDialog.vue?vue&type=template&id=2045cb81&scoped=true"
import script from "./commitDialog.vue?vue&type=script&lang=js"
export * from "./commitDialog.vue?vue&type=script&lang=js"
import style0 from "./commitDialog.vue?vue&type=style&index=0&id=2045cb81&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2045cb81",
  null
  
)

export default component.exports